import script from "./RegistrationCultureChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationCultureChart.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationCultureChart.vue?vue&type=style&index=0&id=70dc70aa&lang=scss"

const __exports__ = script;

export default __exports__